export const KEY_KIDS_TITLE_INDEX = '{{kidstitleIndex}}';
export const KEY_KIDS_TITLE = '{{kidstitle}}';
export const KEY_KIDS_HERONAME = '{{heroname}}';
export const KEY_STRENGHT = '{{strength}}';
export const KEY_STRENGHT_B = '{{strengthB}}';
export const KEY_ACTIVITY = '{{activity}}';
export const KEY_PARENT_AB_NAME = '{{parentname}}';
export const KEY_PARENT_A_NAME = '{{ParentAName}}';
export const KEY_PARENT_B_NAME = '{{ParentBName}}';
export const KEY_PARENT_COMBO = '{{iorwe}}';
export const KEY_GENDER_INDEX = '{{genderIndex}}';
